import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';

@Injectable({ providedIn: 'root' })
export class LanguageService {
    private readonly STORAGE_KEY = 'app_locale';
    private readonly SUPPORTED_LOCALES = ['pt-BR', 'en-US', 'es-ES'] as const;
    private readonly DEFAULT_LOCALE = 'pt-BR';

    private localeSubject = new BehaviorSubject<string>(this.DEFAULT_LOCALE);
    readonly currentLocale$ = this.localeSubject.asObservable();

    constructor(private translateService: TranslateService) {}

    init(): Observable<any> {
        const locale = this.resolveLocale();
        this.localeSubject.next(locale);
        return this.translateService.use(locale);
    }

    setLocale(locale: string): void {
        localStorage.setItem(this.STORAGE_KEY, locale);
        this.localeSubject.next(locale);
        this.translateService.use(locale);
    }

    enforceAccountDefault(multipleLanguagesEnabled?: boolean): void {
        if (!multipleLanguagesEnabled) {
            this.setLocale(this.DEFAULT_LOCALE);
        }
    }

    saveLocale(locale: string): void {
        localStorage.setItem(this.STORAGE_KEY, locale);
    }

    get currentLocale(): string {
        return this.localeSubject.value;
    }

    private resolveLocale(): string {
        const stored = localStorage.getItem(this.STORAGE_KEY);
        if (stored && this.SUPPORTED_LOCALES.includes(stored as any)) {
            return stored;
        }
        return this.detectBrowserLocale();
    }

    private detectBrowserLocale(): string {
        const lang = navigator.language;
        if (lang.startsWith('en')) return 'en-US';
        if (lang.startsWith('es')) return 'es-ES';
        if (lang.startsWith('pt')) return 'pt-BR';
        return 'en-US';
    }
}
